import React from 'react';
import './Footer.scss';

const Footer = () =>
  <div className="footer-container">
    <div className="roller">
      home  |  register  |  login  |  english  |  euro
    </div>
    Sweet Inn
  </div>;

export default Footer;



// WEBPACK FOOTER //
// ./src/components/Footer/Footer.js